import { useTranslate } from '@tolgee/react';
import DecorateTitle from 'components/DecorateTitle';
import SettingItemContainer from './SettingItemContainer';
import SwitchWithText from './SwitchWithText';
import {
  useBrowserSettings,
  useSetBrowserSettings,
} from 'hooks/business/system/useBrowserSettings';

export const BrowserSetting = () => {
  const { t } = useTranslate();
  const browserSettings = useBrowserSettings();
  const setBrowserSettings = useSetBrowserSettings();

  return (
    <>
      <DecorateTitle>{t('ViewSystem.system.title.browser')}</DecorateTitle>
      <SettingItemContainer>
        <SwitchWithText
          value={browserSettings === 'system'}
          title={t('ViewSystem.system.title.browser.system')}
          checkedChildren={t('antd.switch.on.text')}
          unCheckedChildren={t('antd.switch.off.text')}
          onChange={(checked) => {
            setBrowserSettings(checked ? 'system' : undefined);
          }}
        />
      </SettingItemContainer>
    </>
  );
};
